// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4e292563f797c9c5e8e3","655":"e4781fb6a91261d2cb03"}[chunkId] + ".js";
};